export type { TableOfGeneralStandardChineseCharactersDataset } from "table-of-general-standard-chinese-characters";
export { default } from "table-of-general-standard-chinese-characters";
